import * as React from 'react';
import { UIHeading2, Image, UIText3, UIHeading3 } from '@cian/ui-kit';
import * as styles from './Slide.css';

interface ISlideProps {
  position: number;
  name: React.ReactNode;
  logo?: string;
  rate: string;
  licenseText: string;
  amountText: string;
  initialInstallment: string;
  maxLoanTerm: string | null;
}

export function Slide({
  position,
  name,
  logo = '',
  rate,
  initialInstallment,
  maxLoanTerm,
  licenseText,
  amountText,
}: ISlideProps) {
  return (
    <article data-testid={`bank-slide--${position}`} className={styles['container']}>
      <div className={styles['top']}>
        <div className={styles['title']}>
          <UIHeading2 data-testid="bank-name">{name}</UIHeading2>
        </div>

        <div className={styles['logo']}>
          <Image src={logo} borderRadius="50%" width={48} height={48} />
        </div>
      </div>

      <ul className={styles['bottom']}>
        <li className={styles['item']}>
          <div className={styles['subtitle']}>
            <UIText3 color="black_60">Сумма кредита</UIText3>
          </div>
          <UIHeading3 data-testid="bank-amount">{amountText}</UIHeading3>
        </li>
        <li className={styles['item']}>
          <div className={styles['subtitle']}>
            <UIText3 color="black_60">Ставка</UIText3>
          </div>
          <UIHeading3 data-testid="bank-rate">{rate}</UIHeading3>
        </li>
        <li className={styles['item']}>
          <div className={styles['subtitle']}>
            <UIText3 color="black_60">Первый взнос</UIText3>
          </div>
          <UIHeading3 data-testid="bank-initial">{initialInstallment}</UIHeading3>
        </li>
        <li className={styles['item']}>
          <div className={styles['subtitle']}>
            <UIText3 color="black_60">Срок кредита</UIText3>
          </div>
          {maxLoanTerm && <UIHeading3 data-testid="bank-max-loan">{maxLoanTerm}</UIHeading3>}
        </li>
      </ul>
      <UIText3 data-testid="bank-license" color="black_60">
        {licenseText}
      </UIText3>
    </article>
  );
}
